import useAfterMount from '@rio-cloud/rio-uikit/useAfterMount';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { updateAssetId } from './routeHelper';

export const useRouteState = (callback: () => void) => {
    const { pathname, search } = useLocation();
    const searchRef = useRef('');
    const pathnameRef = useRef('');
    const [hasHydratedRouteState, setHasHydratedRouteState] = useState(false);

    useEffect(() => {
        if (searchRef.current === search && pathnameRef.current === pathname) {
            return;
        }
        callback();
        searchRef.current = search;
        pathnameRef.current = pathname;
        setHasHydratedRouteState(true);
    }, [pathname, search, callback]);

    return hasHydratedRouteState;
};

export const useUpdateRoute = ({
    newSubResource,
    newSearch,
    enabled = true,
}: {
    newSubResource: string | undefined;
    newSearch: string;
    enabled?: boolean;
}) => {
    const navigate = useNavigate();
    const { pathname, search } = useLocation();

    const newPathname = updateAssetId(pathname, newSubResource);

    useAfterMount(() => {
        if (!enabled) {
            return;
        }

        if (pathname !== newPathname || search !== newSearch) {
            navigate(newPathname + newSearch);
        }
    }, [enabled, newPathname, newSearch, navigate, pathname, search]);
};
